export default {
  header: {
    title: '💛 Dar gorjeta à equipa',
    subtitle: '100% vai para a equipa',
  },
  buttons: {
    other: 'Outro',
    none: 'Nenhuma',
  },
  summary_label: 'Gorjeta',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} é o valor máximo de gorjeta',
      },
    },
  },
};
